import { URL } from "../../helpers/variableHelper";

const Home = () => {
  return (
    <div className="row mb-4 mx-4 mt-7rem">
      <div className="col-12 mt-4">
        <div className="rounded bg-white p-2 shadow">
          <div className="container mb-4 mt-4">
            <div className="accesosTLC">
              <div className="col-9 mx-auto">
                <div className="row justify-content-center">
                  <div className="col-12 text-center">
                    <a href={URL}>
                      <img src={require("../../assets/img/SG_acceso.png")} className="flex-item link4" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
